import { useEffect, useState } from "react";

interface SignatureCelebrationProps {
  isActive: boolean;
}

interface FallingEmoji {
  id: number;
  emoji: string;
  left: number;
  animationDuration: number;
  animationDelay: number;
  size: number;
}

export function SignatureCelebration({ isActive }: SignatureCelebrationProps) {
  const [emojis, setEmojis] = useState<FallingEmoji[]>([]);

  useEffect(() => {
    if (!isActive) return;

    // Emojis Smile Event (activités)
    const emojiList = ["🎳", "🏎️", "🎤"];

    // Générer 30 emojis qui tombent
    const fallingEmojis: FallingEmoji[] = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      emoji: emojiList[Math.floor(Math.random() * emojiList.length)]!,
      left: Math.random() * 100, // Position horizontale en %
      animationDuration: Math.random() * 2 + 3, // 3-5 secondes
      animationDelay: Math.random() * 2, // 0-2 secondes de délai
      size: Math.random() * 30 + 30, // 30-60px
    }));

    setEmojis(fallingEmojis);

    // Nettoyer après 7 secondes
    const timeout = setTimeout(() => {
      setEmojis([]);
    }, 7000);

    return () => {
      clearTimeout(timeout);
    };
  }, [isActive]);

  if (!isActive || emojis.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[10001] overflow-hidden">
      {emojis.map((item) => (
        <div
          key={item.id}
          className="absolute animate-fall"
          style={{
            left: `${item.left}%`,
            fontSize: `${item.size}px`,
            animationDuration: `${item.animationDuration}s`,
            animationDelay: `${item.animationDelay}s`,
            top: "-100px",
          }}
        >
          {item.emoji}
        </div>
      ))}

      <style>{`
        @keyframes fall {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0.7;
          }
        }

        .animate-fall {
          animation: fall linear forwards;
        }
      `}</style>
    </div>
  );
}
